exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media print {\n.exit-button[data-v-4c070a39]{\n        display: none;\n}\n.footer[data-v-4c070a39]{\n        display: block;\n}\n}\n", ""]);

// exports
